import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Heart.svg'

export const IconHeart = IconSVG as IconComponent
